import { Text } from "@certn/cascadia";
import { formatFileSize } from "@certn/utils";

import { FileUploadProps } from "./types";
import { FileInfo } from "./utils";
interface Props {
  file: FileInfo;
  fileInfo: FileUploadProps["showFileInfo"];
}

export function FileSubtitle(props: Props) {
  const { file, fileInfo } = props;

  if (file.subtitle) {
    return <Text color="text-weak">{file.subtitle}</Text>;
  }

  if (fileInfo === "size") {
    return <Text color="text-weak">{formatFileSize(file.size, 2)}</Text>;
  }

  if (fileInfo === "type") {
    return <Text color="text-weak">{file.type}</Text>;
  }

  return null;
}
